import React, { useEffect, useState } from "react";
import { Box, Typography, Autocomplete, TextField, Grid } from "@mui/material";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
import { getAttendanceSummary } from "../../services/attendanceReport.service";
import { getAllUsers } from "../../services/user.service";
import Styles from "./AttendanceReport.module.scss";

const { RangePicker } = DatePicker;

const AttendanceReportSummary = ({ onRowClick, preservedFilters }) => {
    const [data, setData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);

    // Filters
    const [dateRange, setDateRange] = useState(
        preservedFilters?.dateRange || [dayjs().startOf('month'), dayjs()]
    );
    const [employees, setEmployees] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState(
        preservedFilters?.selectedEmployees || []
    );

    useEffect(() => {
        fetchEmployees();
    }, []);

    useEffect(() => {
        if (dateRange && dateRange[0] && dateRange[1]) {
            fetchData();
        }
    }, [page, rowsPerPage, dateRange, selectedEmployees]); // Dependencies for refetching

    const fetchEmployees = async () => {
        try {
            // Fetch enabled users only
            const res = await getAllUsers({ isEnabled: true });
            if (res?.data?.data) {
                setEmployees(res.data.data);
            }
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const params = {
                startDate: dateRange[0].format('YYYY-MM-DD'),
                endDate: dateRange[1].format('YYYY-MM-DD'),
                employeeIds: selectedEmployees.map(e => e._id),
                page: page + 1,
                limit: rowsPerPage,
                sortBy: "userName",
                sortOrder: "asc"
            };

            const res = await getAttendanceSummary(params);
            if (res) {
                const formattedData = (res.data || []).map(item => {
                    const totalWorkingCount = Math.max(0,
                        (item.totalWorkingDays || 0) -
                        (item.totalLeaveCount || 0) -
                        (item.totalLOPCount || 0) +
                        (item.earnedLeaveCount || 0)
                    );

                    return {
                        ...item,
                        totalWorkingCount,
                        totalWorklogTime: formatDuration(item.totalWorklogTime)
                    };
                });
                setData(formattedData);
                setTotalCount(res.totalCount || 0);
                console.log(res.totalCount)
            }
        } catch (error) {
            console.error("Error fetching summary:", error);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const columns = [
        { id: 'userName', label: 'User Name', numeric: false },
        // { id: 'shift', label: 'Shift', numeric: false },
        { id: 'totalWorkingDays', label: 'Working Days', numeric: false },
        { id: 'totalLeaveCount', label: 'Leave Count', numeric: false },
        { id: 'totalLOPCount', label: 'LOP Count', numeric: false },
        { id: 'totalWorkingCount', label: 'Working Count', numeric: false },
        { id: 'earnedLeaveCount', label: 'OT Counts', numeric: false },
        // { id: 'totalWorklogTime', label: 'Worklog Time', numeric: false },
    ];

    const formatDuration = (seconds) => {
        if (!seconds) return "0h 0m";
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        return `${hours}h ${minutes}m`;
    };

    const overviewTableConfig = {
        isMore: true,
        // isAction: true,
        isAdmin: true,
        isView: true,
    };

    // We can add a custom 'view' action that calls onRowClick
    const handleView = (row) => {
        console.log("Row clicked:", row);
        onRowClick(row, { dateRange, selectedEmployees });
    };


    return (
        <Box>
            <Box className={Styles.pageHeader}>
                <Typography className={Styles.title}></Typography>

                <Box className={Styles.filters}>
                    <RangePicker
                        format="DD-MM-YYYY"
                        value={dateRange}
                        onChange={(dates) => setDateRange(dates)}
                        className={Styles.dateRangePicker}
                        allowClear={false}
                    />

                    {/* <Autocomplete
                        multiple
                        options={employees}
                        getOptionLabel={(option) => option.firstName + " " + option.lastName}
                        value={selectedEmployees}
                        onChange={(event, newValue) => setSelectedEmployees(newValue)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Select Employees"
                                size="small"
                            />
                        )}
                        className={Styles.employeeSelect}
                        sx={{ width: 300 }}
                    /> */}
                </Box>
            </Box>

            <MasterCommonTable
                tableConfig={overviewTableConfig}
                columns={columns}
                data={data}
                tableTotalCount={totalCount}
                page={page}
                isPaginationBar={false}
                // isServerSide={true}
                rowsPerPage={rowsPerPage}
                handleChangePage={handlePageChange}
                handleChangeRowsPerPage={handleRowsPerPageChange}
                handleView={handleView}
                loading={loading}
            />
        </Box>
    );
};

export default AttendanceReportSummary;
